export default "__VITE_ASSET__2U4yjEYl__"